export default __webpack_public_path__ + "static/media/SolSea_Logo.29554f5d.svg";